import { Autocomplete, Chip, CircularProgress, Grid, TextField, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";

const WhiteAlien = "#ffffff";

export default function WorkflowFiscalYearFilter({
  fiscalYearSelection,
  setFiscalYearSelection,
  fiscalYearOptions,
  hideFiscalYearHeader,
  isDisabled,
  disabledText,
  setTotalCount
}) {
  const [fiscalYearOpen, setFiscalYearOpen] = useState(false);
  const fiscalYearLoading = fiscalYearOpen && fiscalYearOptions.length === 0;

  return (
    <Fragment>
      {hideFiscalYearHeader ? null :
        <Grid item size={1} style={{ paddingTop: 10}}>
        <span>
          <label style={{ color: WhiteAlien }}>Fiscal Year:</label>
        </span>
      </Grid>
       }
      <Grid item size={3}  style={{paddingTop: 10}}>
        <Autocomplete
          //multiple
          disabled={isDisabled}
          disableClearable
          id="fiscalYearDemo"
          value={fiscalYearSelection}
          style={{ backgroundColor: WhiteAlien }}
          onChange={(event, newValue) => {
            setFiscalYearSelection(newValue);
            if(setTotalCount)
            {
              setTotalCount(0);
            }
          }}
          onOpen={() => {
            setFiscalYearOpen(true);
          }}
          onClose={() => {
            setFiscalYearOpen(false);
          }}
          isOptionEqualToValue={(option, value) =>
            option.FiscalYear === value.FiscalYear
          }
          getOptionLabel={(option) => {
            return option.FiscalYear;
          }}
          options={fiscalYearOptions}
          getOptionDisabled={(option) => {
            if (fiscalYearSelection) {
              const selected = fiscalYearSelection.FiscalYear;
              if (
                selected &&
                option &&
                selected.includes(option.FiscalYear)
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          }}
          loading={fiscalYearLoading}
          renderTags={(tagValue, getTagProps) =>
            tagValue.map((option, index) => (
              <Chip
                label={option.FiscalYear}
                {...getTagProps({ index })}
                disabled={false}
              />
            ))
          }
          renderInput={(params) => (
            <Tooltip
              title={
                (isDisabled && disabledText) ? <div style={{ whiteSpace: 'pre-line' }}>{disabledText ?? ""}</div> : null
              } 
              enterDelay={100}
            >
              <TextField
              {...params}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {fiscalYearLoading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params?.InputProps?.endAdornment}
                    </React.Fragment>
               
                  )
                }
              }}
              />
            </Tooltip>
          )}
        />     
      </Grid>
    </Fragment>
  );
}

WorkflowFiscalYearFilter.propTypes = {
  fiscalYearSelection: PropTypes.object,
  setFiscalYearSelection: PropTypes.func,
  fiscalYearOptions: PropTypes.array
};
